import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { async, Observable, throwError, concat, of, from, Subscription } from 'rxjs';
import { map, switchMap, concatMap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

import { GetglobalsettingsService } from '../../services/getglobalsettings.service'
import { ProductGroup } from '../../shared/product-group';
import { RestApiService } from '../../services/rest-api.service';

/**
 * Modal dialog for searching and selecting a product group from the group tree.
 *
 * Wraps the product-group tree selector inside a PrimeNG dialog.  The caller
 * may optionally seed `groupId` to pre-select a group on open.  When the user
 * confirms, the chosen `ProductGroup` is emitted via `selectedGroup`.
 * `displayChange` emits `false` on hide for two-way `[(display)]` binding.
 *
 * `canClose` guards the confirm button — enabled only when a group is selected.
 * `ngOnDestroy` unsubscribes `topGroupQuery`, `childGroupQuery`, and
 * `selectedGroupQuery` to prevent memory leaks.
 */
@Component({
  selector: 'app-prodgroup-search',
  templateUrl: './prodgroup-search.component.html',
  styleUrls: ['./prodgroup-search.component.css']
})
export class ProdgroupSearchComponent implements OnInit, OnChanges, OnDestroy {

  private topGroupQuery: Subscription;
  private childGroupQuery: Subscription;
  private selectedGroupQuery: Subscription;

  displayPS: boolean = false;

  /** Dialog header text. */
  @Input()
  header: string = "Поиск группы товаров";

  modal: boolean = true;
  loading: boolean;

  group: ProductGroup;

  /** True when a group has been selected; gates the confirm button. */
  public get canClose(): boolean { return (this.group ? true : false);}

  /** Controls dialog visibility; supports two-way binding via `displayChange`. */
  @Input()
  display: boolean = false;

  /** Optional seed group ID to pre-select a group when the dialog opens. */
  @Input()
  groupId: number;

  /** Emits the selected `ProductGroup` when the user confirms. */
  @Output()
  public selectedGroup: EventEmitter<ProductGroup> = new EventEmitter();

  /** Emits `false` on dialog hide to support two-way `[(display)]` binding. */
  @Output() displayChange = new EventEmitter();

  constructor(private restapi: RestApiService, private messageService: MessageService) { }

  /** Unsubscribes all active group-tree query subscriptions. */
  ngOnDestroy(): void {
    if (this.topGroupQuery) { this.topGroupQuery.unsubscribe(); }
    if (this.childGroupQuery) { this.childGroupQuery.unsubscribe(); }
    if (this.selectedGroupQuery) { this.selectedGroupQuery.unsubscribe(); }
  }

  /** No-op initialisation. */
  ngOnInit(): void {
  }

  /** Reacts to `groupId` changes — currently a no-op (case body is empty). */
  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ProdgroupSearchComponent ngOnChanges');
    for (let propName in changes) {
      let change = changes[propName];
      console.log('*** ProdgroupSearchComponent ngOnChanges (actual): ' + propName + ' ' + JSON.stringify(change.currentValue));
      //console.log('*** ProdgroupSearchComponent ngOnChanges (was):    ' + propName + ' ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'groupId':
          break;
      }
    }
  }

  /** No-op — called by PrimeNG dialog `(onShow)`. */
  onShowDialog() {
    console.log('*** ProdgroupSearchComponent onShow: ');
  }

  /** Emits `false` via `displayChange` to close the dialog. */
  onHideDialog() {
    console.log('*** ProdgroupSearchComponent onHide');
    this.displayChange.emit(false);
  }

  /** Stores the `ProductGroup` emitted by the inner tree selector. */
  onSelectedGroup(event) {
    console.log('*** ProdgroupSearchComponent onSelectedGroup: ' + JSON.stringify(event));
    this.group = event;
  }

  /** Emits the selected `group` via `selectedGroup` and closes the dialog. */
  onConfirm(text: string) {
    console.log('*** ProdgroupSearchComponent onConfirm: ' + text);
    this.selectedGroup.emit(this.group);
    this.display = false;
  }

}
